import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { FileListService } from '@schoolbelle/api/file';
import { Subscription } from 'rxjs';
import { TranslationViewerComponent } from '../translation-viewer';

@Component({
  selector: 'app-text-viewer',
  templateUrl: './text-viewer.component.html',
  styleUrls: ['./text-viewer.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class TextViewerComponent extends TranslationViewerComponent {
  // double declaration due to build error
  @Input() set content(v:string|{[lang:string]:string}) {
    if (typeof v === 'string') {
      this._content = {[this.lang]:v}
    } 
    else {
      this._content = v;
    } 
  }
  @Input() set lang(v:string) {
    if (this._lang === v) return;
    this._lang = v;
    if (this.inited) this.cdRef.detectChanges();
  }  
  // double declaration due to build error


  @Input() mailmerge:MailMergeItem[] = [];
  @Input() mailmergeIndex:number = 1;
  @Input() height = 'auto';
  @Input() query:string;



  get mailmergeItem () {
    return this.mailmerge && this.mailmerge[this.mailmergeIndex];
  }
  @Input() filelist:FileListService = new FileListService();
  subscription = new Subscription();
  ngOnInit () {
    super.ngOnInit();
    this.subscription.add(
      this.filelist.onChange.subscribe((()=>this.cdRef.detectChanges()))
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
}
